import { EventType, Expression, HtmlType } from '../../types.js'
import { jsonClass, jsonProperty } from '@sumbricht/json-class-serializer'
import { StaticEntityBlock } from './static-entity-block.js'
import { Parameter } from '../../script/parameter.js'
import { ScreenEditorInput } from '../decorators/screen-editor-input.js'

@jsonClass('DropdownBlock')
export class DropdownBlock extends StaticEntityBlock {
	@jsonProperty(Expression)
	@ScreenEditorInput({
		inputType: 'code',
		order: 3,
		label: () => 'Empty Selection',
		codeLanguage: 'ts',
		editorSize: 'singleline',
		tsReturnType: () => '[any, string, boolean] | undefined',
		isBinding: false,
		isMandatory: () => false,
		tooltip: () => ({
			text: "Configuration tuple: [value, label, validation] — defines the option's bound value, display label, and validation rules.\nLeave blank to disable this option.",
		}),
	})
	emptySelection = new Expression()

	@ScreenEditorInput({
		inputType: 'checkbox',
		order: 10,
		label: 'Multiple selection',
	})
	@jsonProperty(Boolean)
	isMultipleSelection: boolean = false

	producePreview(): HtmlType {
		return `<select tabindex="-1"><option>${this.exampleText || 'Option'}</option></select>`
	}

	getEditorCategory(): string {
		return 'Core'
	}

	get allowedEventTypes(): EventType[] {
		return [
			{
				name: 'selectionChange',
				parameters: [
					new Parameter({
						name: 'selection',
						type: `any${this.isMultipleSelection ? '[]' : ''}`,
						defaultExpression: '$event?.value',
					}),
				],
			},
		]
	}
}
